module.exports = require("ramda/src/pipeP");